import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { addNotification } from 'actions/globalActions';

import Button from 'components/common/Button';

import './styles.scss';

const StopwordsTableRowForm = ({ stopword, onSubmitForm }) => {

  const dispatch = useDispatch();

  // form values

  console.log('safewords inside row form:', stopword);

  const [selectedStopword, setSelectedStopword] = useState(stopword.stopword);
  const [safewords, setSafewords] = useState(stopword.safewords);
  const [newSafeword, setNewSafeword] = useState('');

  const handleStopwordChange = (e) => {
    const { value } = e.target;
    setSelectedStopword(value);
  };

  const validateName = (name) => {
    if (name.length === 0) {
      return {
        type: 'warning',
        title: 'Invalid Stopword',
        description: 'Stopword field cannot be empty'
      };
    }
    return null;
  };

  const validateSafeword = (word) => {
    if (word.length === 0) {
      return {
        type: 'warning',
        title: 'Invalid Safeword',
        description: 'Safeword cannot be empty'
      };
    }
    return null;
  };

  const handleNewSafeword = (e) => {
    const {value} = e.target;
    setNewSafeword(value);
  };

  const handleAddNewSafeword = (e) => {
    e.preventDefault();
    const error = validateSafeword(newSafeword);
    console.log('error:', error);
    if (error === null) {
      const word = [...safewords, newSafeword.trim()];
      console.log(word);
      setSafewords(word);
      setNewSafeword('');
    } else {
      dispatch(addNotification(error));
    }
  };

  const handleRemoveSafeword = (index) => {
    console.log(index);
    safewords.splice(index, 1);
    setSafewords([...safewords]);
  };

  const submitForm = () => {
    const validationErrors = [validateName(selectedStopword)].filter(e => e !== null);
    if (validationErrors.length === 0) {
      onSubmitForm({
        stopword: selectedStopword,
        safewords: safewords,
      });
    } else {
      dispatch(addNotification(validationErrors[0]));
    }
  };

  return (
    <div className="control">
      <div className="field">
        <label className="label">Stopword</label>
        <input
          className="input"
          name="name"
          type="text"
          value={selectedStopword}
          onChange={handleStopwordChange}
        />
        <p className="help">Input exact string for matching</p>
      </div>

      <div className="field">
        <label className="label">Safewords</label>
        <form onSubmit={handleAddNewSafeword}>
          <input
            className="input"
            name="DNS name"
            type="text"
            value={newSafeword}
            onChange={handleNewSafeword}
          />
          <Button>Add Safeword</Button>
        </form>
        <div className="columns m-1">
          <div className="column">
            <ul>
              {safewords.map((item, index) => (
                <li key={index} className="mb-2">
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="column">
            <ul>
              {safewords.map((item, index) => (
                <li key={index} className="mb-2">
                  <Button size="small" type="outlined" rounded={true} onClick={() => handleRemoveSafeword(index)} >X</Button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Button className="is-pulled-right" type="text" onClick={submitForm}>
        Save Changes
      </Button>
    </div>
  );
};

StopwordsTableRowForm.propTypes = {
  stopword: PropTypes.shape({
    id: PropTypes.string,
    stopword: PropTypes.string,
    safewords: PropTypes.array
  }),
  onSubmitForm: PropTypes.func,
};

export default StopwordsTableRowForm;

